const joinExistingStrings = (strings, separator)=>{
    return strings.filter((value)=>!!value
    ).join(separator || '');
};

export { joinExistingStrings };
//# sourceMappingURL=join-existing-strings.js.map
